<template>
  <main>
    <b-container v-if="pool">
      <div class="page-breadcrumb">
        <router-link
            :to="{ name: 'PoolView', params: { id: pool._id, ref: 'default' } }"
            ><i class="fa fa-angle-left" /> Back to pool</router-link
          >
      </div>

      <div class="section-header">
        <h1 class="heading">Edit pool</h1>

        <div class="actions"></div>
      </div>

      <div class="layoutcard">
        <b-row>
          <b-col cols="8" lg="7">
            <b-form @submit.prevent="submit">
              <b-row>
                <b-col cols="12">
                  <b-form-group
                    id="input-group-name"
                    label="Name"
                    label-for="input-name"
                  >
                    <b-form-input
                      id="input-name"
                      v-model.trim="form.name"
                      v-validate="{ required: true, max: 100 }"
                      type="text"
                      placeholder="Name"
                      size="lg"
                      data-vv-name="name"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group
                    id="input-group-description"
                    label="Description (Max 1000 Chars)"
                    label-for="input-description"
                    class="mb-4"
                  >
                    <b-form-textarea
                      id="input-description"
                      v-model.trim="form.description"
                      v-validate="{ required: true, max: 400 }"
                      placeholder="Description"
                      size="lg"
                      rows="8"
                      data-vv-name="description"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
                
                <b-col class="text-right" cols="12">
                  <div class="form-footer">
                    <b-btn variant="primary" size="lg" type="submit">
                      <i class="fa fa-download" /> Save
                    </b-btn>
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </main>
</template>

<script>
import { setTimeout } from "timers";
import { mapActions } from "vuex";
import InitAdmin from "@/components/Admin/Shared/InitAdmin";

export default {
  name: "PoolEdit",
  extends: InitAdmin,
  data() {
    return {
      pool: null,
      form: {
        name: null,
        description: null
      }
    };
  },
  mounted() {
    this.loadPool({ id: this.$route.params.id }).then(res => {
      this.pool = res;
      this.form.name = this.pool.name;
      this.form.description = this.pool.description;
    });
  },
  methods: {
    ...mapActions(["loadPool", "updatePool"]),
    submit() {
      if(this.pool.pool_locked){
        this.$toasted.show("Update Restricted! Pool is in use of one of active models", { type: "error" });
      }
      else{
        let pool = this.pool;
        pool.name = this.form.name;
        pool.description = this.form.description;
        this.updatePool({
          id: this.pool._id,
          pool: pool
        }).then(() => {
          this.$toasted.show("Pool saved");
          setTimeout(() => {
            this.$router.push({
              name: "PoolView",
              params: { id: this.pool._id }
            });
          }, 1000);
        });
      }
    }
  }
};
</script>
